import { MassUnit } from "../../../../types/process/process.types";
import {
  ApiExternalStorageRecord,
  ApiExternalTransportRecord,
  ApiFacility,
  ExternalTransportRecord,
  InternalStorageRecord,
  TransportType
} from "../../../../types/prodcut-data-review/product-data.types";
import {
  MASS_UNIT_MAP as STORAGE_MASS_UNIT_MAP,
  STORAGE_ENV_MAP
} from "../shared/constants/measurementUnits.constants";

export const toExternalTransportRecord = (
  api: ApiExternalTransportRecord,
  transportTypeMap: Record<number, string>
): ExternalTransportRecord => ({
  id: api._id,
  name: api.externalTransportName,
  transportType: (transportTypeMap[api.transportationType] ?? "") as TransportType | "",
  from: api.from,
  to: api.to,
  weight: api.weight,
  weightUnit: (STORAGE_MASS_UNIT_MAP[api.weightUnit] ?? "kg") as MassUnit,
  distance: api.distance,
  isEditing: false
});

export const toExternalStorageRecord = (api: ApiExternalStorageRecord): InternalStorageRecord => ({
  id: api._id,
  name: api.externalStorageName,
  dataType: (api.dataType || "Specific") as "Specific" | "Generic",
  environment: STORAGE_ENV_MAP[api.storageEnv] ?? "",
  warehouseName:
    typeof api.facilityId === "string"
      ? api.facilityId
      : (api.facilityId as ApiFacility)?.facilityName ?? "",
  storageTemperature: api.storageTemperature,
  warehouseSize: api.warehouseSize,
  weight: api.weight,
  weightUnit: STORAGE_MASS_UNIT_MAP[api.weightUnit] ?? "kg",
  electricity: api.electricity,
  utilization: api.warehouseUtilization,
  storageDays: api.storageDays,
  isEditing: false
});
